import { toFixed } from 'humanize-plus'
import * as R from 'ramda'

/* KPI card helpers */
export const parseMetric = R.pipe(
  R.head,
  (val: number) => toFixed(val, 1),
  parseFloat
)
